<template>
    <div>
        <notifications></notifications>
        <router-view></router-view>
    </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useUnitStore } from '@/stores/units';
import { useThemeStore } from './stores/theme';

export interface IRTL {
    isRTL: boolean;
    disableRTL: () => void;
}

export interface ISidebar {
    showSidebar: boolean;
    sidebarLinks: [];
    displaySidebar: (isExpand?: boolean) => void;
}

const rtl = inject<IRTL>('rtl');
const sidebar = inject<ISidebar>('sidebar');
const route = useRoute();
const disableRTL = () => {
    if (!rtl?.isRTL) {
        rtl?.disableRTL();
    }
};

const toggleNavOpen = () => {
    let root = document.getElementsByTagName('html')[0];
    root.classList.toggle('nav-open');
};

watch(() => route, disableRTL, { immediate: true });
watch(() => sidebar?.showSidebar, toggleNavOpen);

onMounted(async () => {
    await useUnitStore().getAllFromRemote();
    useThemeStore().initTheme();
});
</script>
